import Lookup from './lookup.js';

export default class IssuerOldIdentificationCard extends Lookup
{
    
}
